import { combineReducers } from "redux";
import {frontWebRatingDataReducer} from "./frontWebRating/reducer"
import { survey } from "./survey/reducer";
import { learning } from "./learning/reducer";

const reducers = combineReducers({
  survey,
  frontWebRatingDataReducer,
  learning,
});

export { reducers };
